import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import Home from '.';

interface Paths {
  home: string;
}

const paths: Paths = {
  home: '/home',
};

export default [
  <RouteIfRights exact path={paths.home} key={paths.home} component={Home} rights="reports" />,
];

export { paths };
